import { render, staticRenderFns } from "./UnderlyingReports.vue?vue&type=template&id=38b83ce5&scoped=true&"
import script from "./UnderlyingReports.js?vue&type=script&lang=js&"
export * from "./UnderlyingReports.js?vue&type=script&lang=js&"
import style0 from "./UnderlyingReports.vue?vue&type=style&index=0&id=38b83ce5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b83ce5",
  null
  
)

export default component.exports